import React, { useState } from "react";
import PropTypes from "prop-types";

function NameSelectorModal({ patientName, userName, onConfirm, onClose }) {
    const [inputValue, setInputValue] = useState(patientName || "");
    const hasDistinctUser = userName && (!patientName || userName.toLowerCase() !== patientName.toLowerCase());

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
            onClick={onClose}
        >
            <div
                className="bg-white-50 rounded-2xl shadow-xl p-8 w-full max-w-md flex flex-col gap-5"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-xl font-bold text-gray-800">Select Name for DRX</h2>

                <div className="flex flex-col gap-2">
                    <p className="text-sm text-gray-500 font-medium">Quick select</p>
                    <div className="flex gap-3 flex-wrap">
                        {patientName && (
                            <button
                                onClick={() => setInputValue(patientName)}
                                className={`flex-1 py-2 px-4 rounded-xl border-2 font-semibold transition-colors ${
                                    inputValue === patientName
                                        ? "border-[#28A48B] bg-[#e6f7f4] text-[#28A48B]"
                                        : "border-gray-300 text-gray-700 hover:border-[#28A48B]"
                                }`}
                            >
                                Patient: {patientName}
                            </button>
                        )}
                        {hasDistinctUser && (
                            <button
                                onClick={() => setInputValue(userName)}
                                className={`flex-1 py-2 px-4 rounded-xl border-2 font-semibold transition-colors ${
                                    inputValue === userName
                                        ? "border-[#28A48B] bg-[#e6f7f4] text-[#28A48B]"
                                        : "border-gray-300 text-gray-700 hover:border-[#28A48B]"
                                }`}
                            >
                                User: {userName}
                            </button>
                        )}
                    </div>
                </div>

                <div className="flex flex-col gap-1">
                    <label className="text-sm text-gray-500 font-medium">Or enter manually</label>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        className="border border-gray-300 rounded-xl px-4 py-2 text-gray-800 focus:outline-none focus:border-[#28A48B]"
                        placeholder="Enter name..."
                    />
                </div>

                <div className="flex gap-3 justify-end mt-2">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 rounded-xl border border-gray-300 text-gray-600 font-semibold hover:bg-white-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(inputValue.trim())}
                        disabled={!inputValue.trim()}
                        className="px-6 py-2 rounded-xl bg-[#28A48B] text-white font-semibold hover:bg-[#1f8c76] disabled:opacity-50"
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
}

NameSelectorModal.propTypes = {
    patientName: PropTypes.string,
    userName: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { NameSelectorModal };
